export default function debounce(fn, delay = 300) {
  let timer = null

  function debounced(...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }

  debounced.cancel = () => {
    clearTimeout(timer)
    timer = null
  }

  debounced.flush = () => {
    if (timer) {
      clearTimeout(timer)
      fn()
      timer = null
    }
  }

  return debounced
}